import React from 'react';
import { Skeleton, Box } from '@mui/material';

// Function to generate random height percentages between min and max
const getRandomHeight = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// Skeleton for Bar Chart Loading State
const ChartSkeleton = () => {
  const barHeights = Array.from({ length: 12 }, () => getRandomHeight(20, 90)); // Generate random heights for 5 bars

  return (
    <Box
      sx={{
        width: '100%',
        height: '600px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2,
      }}
    >
      {/* X-axis label skeleton */}
      <Skeleton variant="rectangular" width="90%" height={30} sx={{ mb: 2 }} />
      
      {/* Bars skeleton with random heights */}
      <Box sx={{ display: 'flex', width: '90%', justifyContent: 'space-around', height: '300px' }}>
        {barHeights.map((height, index) => (
          <Skeleton key={index} variant="rectangular" width="5%" height={`${height}%`} />
        ))}
      </Box>

      {/* X-axis category skeletons */}
      <Box sx={{ display: 'flex', width: '90%', justifyContent: 'space-around', mt: 2 }}>
        {barHeights.map((_, index) => (
          <Skeleton key={index} variant="text" width="5%" />
        ))}
      </Box>
    </Box>
  );
};

export default ChartSkeleton;
